/**
 * DC Volt Drop Calculator - Data & constants
 * Resistance per meter (Ω/m) at 20°C for copper conductors
 * Based on ρ = 0.0175 Ω·mm²/m (IEC/BS 7671 reference)
 */

// Cable CSA options (mm²) - standard sizes for DC/PV applications
export const CABLE_CSA_OPTIONS = [
  { id: '1.5', label: '1.5', value: 1.5 },
  { id: '2.5', label: '2.5', value: 2.5 },
  { id: '4', label: '4.0', value: 4 },
  { id: '6', label: '6.0', value: 6 },
  { id: '10', label: '10', value: 10 },
  { id: '16', label: '16', value: 16 },
  { id: '25', label: '25', value: 25 },
  { id: '35', label: '35', value: 35 },
  { id: '50', label: '50', value: 50 },
  { id: '70', label: '70', value: 70 },
  { id: '95', label: '95', value: 95 },
  { id: '120', label: '120', value: 120 },
  { id: '150', label: '150', value: 150 },
  { id: '185', label: '185', value: 185 },
  { id: '240', label: '240', value: 240 },
];

// DC cable types (solar PV and DC applications)
export const CABLE_TYPE_OPTIONS = [
  { id: '', label: 'Select', value: '' },
  {
    id: 'h1z2z2-k',
    label: 'Photovoltaic Solar EN 50618 H1Z2Z2-K Cable',
    value: 'h1z2z2-k',
    dataSheetUrl: 'https://www.elandcables.com/cables/photovoltaic-solar-h1z2z2-k',
  },
  {
    id: 'cu-solar-generic',
    label: 'Cu - Solar PV Cable (Generic)',
    value: 'cu-solar-generic',
  },
];

// Resistivity of copper at 20°C (Ω·mm²/m)
const RHO_COPPER = 0.0175;

/**
 * Get resistance per meter (Ω/m) for a given CSA
 * r = ρ / A
 */
export function getResistancePerMeter(csaMm2) {
  const a = parseFloat(csaMm2);
  if (!a || a <= 0) return null;
  return RHO_COPPER / a;
}
